import { useFieldArray } from 'react-hook-form';

import { Flex } from 'shared';
import { FlexItem } from 'shared_DEPRECATED/components/Flex';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';

import {
  SessionSidebarFieldset,
  SessionSidebarFieldsetLabel,
} from 'features/sessions/components';
import { NextSessionCoachingToolsCard } from 'features/sessions/components/NextSessionForm/CoachingToolsCard';
import { defaultCoachingTool } from 'features/sessions/config';

import { ButtonIcon } from 'shared/components/Button';

const NEXT_SESSION_TOOLS_FIELD_NAME = 'nextSessionTools';

export const NextSessionCoachingToolsSection = () => {
  const {
    fields: coachingTools,
    append,
    remove,
    update,
  } = useFieldArray({
    name: NEXT_SESSION_TOOLS_FIELD_NAME,
  });

  const handleCoachingToolsDelete = (index: number) => {
    if (coachingTools.length === 1) {
      update(index, defaultCoachingTool);
    } else {
      remove(index);
    }
  };

  return (
    <SessionSidebarFieldset>
      <Flex w="100%" justifyContent="space-between">
        <FlexItem alignSelf="center">
          <SessionSidebarFieldsetLabel>
            Next session HDE Modules
          </SessionSidebarFieldsetLabel>
        </FlexItem>
        <ButtonIcon
          aria-label="add tool"
          variant="ghost"
          onClick={() => append(defaultCoachingTool)}
          size="sm"
        >
          <Icon name={iconNames.plus} />
        </ButtonIcon>
      </Flex>
      {coachingTools.map((coachingTool, index) => (
        <NextSessionCoachingToolsCard
          key={coachingTool.id}
          onDelete={() => handleCoachingToolsDelete(index)}
          formKey={`${NEXT_SESSION_TOOLS_FIELD_NAME}.${index}`}
          canBeDeleted={coachingTools.length > 1}
        />
      ))}
    </SessionSidebarFieldset>
  );
};
